import { clearCookie, getCookie } from './cookieUtils';
import { ACCESS_TOKEN, SELECTED_LANGUAGE } from './enums/misc';
import { errorNotification } from 'base/notifications/Notifications';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import { UnauthorizedCustomEventDetailsI } from '../../types/interface';

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}` // url
});

instance.interceptors.request.use(
  config => {
    const accessToken = getCookie(ACCESS_TOKEN);
    const language = getCookie(SELECTED_LANGUAGE);

    if (accessToken) {
      config.headers['Authorization'] = `${accessToken}`;
    }
    config.headers['lang'] = language ? language : 'de';
    config.headers['x-timezone'] =
      Intl.DateTimeFormat().resolvedOptions().timeZone;
    return config;
  },
  error => {
    Sentry.withScope(scope => {
      if (axios.isAxiosError(error)) {
        scope.setExtra('response_body', error.response?.data);
      }
      Sentry.captureException(error);
    });
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    Sentry.withScope(scope => {
      if (axios.isAxiosError(error)) {
        scope.setExtra('response_body', error.response?.data);
      }
      Sentry.captureException(error);
    });
    if (error.response.status === 401 && error.config.url !== '/auth/login') {
      clearCookie(ACCESS_TOKEN);
      window.location.href = '/';
    } else if (error.response.status === 403) {
      window.dispatchEvent(
        new CustomEvent<UnauthorizedCustomEventDetailsI>(
          'showUnauthorizedModal',
          {
            detail: {
              message: error?.response?.data?.message || 'Access denied'
            }
          }
        )
      );
      return Promise.reject(error);
    } else {
      if (error?.response?.data?.message) {
        errorNotification(error?.response?.data?.message);
      }
      return Promise.reject(error);
    }
  }
);

export default instance;
